<template>
  <div class="main-user">
    <el-row>
      <el-form
          :inline="true"
          :model="searchForm"
          class="demo-form-inline search-form"
          size="small"
      >
        <el-form-item style="width: 160px;">
          <el-select
              v-model="searchForm.agentId"
              placeholder="选择机构:"
              clearable
              filterable
          >
            <el-option
                v-for="(item, i) in agentList"
                :key="item.agentId"
                :label="item.agentName"
                :value="item.agentId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch" icon="el-icon-search"
          >查询</el-button
          >
        </el-form-item>
      </el-form>
    </el-row>
    <el-card shadow="never" class="card-fix-height scrollable">
      <el-table
        :data="tableData"
        v-loading="loading"
        row-key="id"
        stripe
        style="width: 100%;overflow-y: auto;"
        :height="tableHeight"
      >
        <el-table-column
          prop="agentName"
          label="机构名称"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="totalCount"
          label="参与人数"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="finishCount"
          label="完成人数"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="finishPercent"
          label="完成率"
          :formatter="({finishPercent}) => {return `${Math.round(finishPercent * 100) / 100}%`}"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
            prop="avgUseTimeStr"
            label="平均用时"
            show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
    </el-card>
    <el-pagination
      class="footer"
      background
      layout="prev, pager, next,total, jumper,sizes"
      :total="tableTotal"
      :current-page="currentPage"
      :page-size.sync="pageSize"
      @current-change="onCurrentPageChange"
      @size-change="handleSizeChange"
      :page-sizes="[20, 100, 500]"
      align="center"
    >
    </el-pagination>
  </div>
</template>

<script>
import MyCollapse from "@/components/Collapse/collapse";
import MyCollapseItem from "@/components/Collapse/collapse-item";
import { getExamAgentList, getExamAgentFinishPager } from "@/api/exam";
import permission from "@/directive/permission"; // 权限判断指令
import { defaultPageConfig } from "@/config/pagination";
export default {
  name: "ExamAgentListHd3",
  directives: { permission },
  components: {
    MyCollapse,
    MyCollapseItem,
  },
  data() {
    return {
      searchForm: {
        examId: '906213770370527233',
        agentId: null,
      },
      tableData: [],
      currentPage: 1,
      tableTotal: -1,
      tablePages: 0,
      loading: false,
      tableLayout: defaultPageConfig.layout,
      pageSize: defaultPageConfig.pageSize,
      agentList: [],
      tableHeight: 600
    };
  },
  watch: {
  },
  computed: {
  },
  activated() {
    this.getPager();
  },
  created() {
    this.getAgentList();
  },
  mounted() {
    let that = this;
    that.$nextTick(() => {
      that.tableHeight =
        document.getElementsByClassName("card-fix-height")[0].clientHeight - 40;
    });
  },
  methods: {
    handleSizeChange() {
      this.getPager();
    },
    getAgentList() {
      let that = this;
      getExamAgentList({examId: this.searchForm.examId}).then(res => {
        if (res && res.code === 200) {
          that.agentList = res.data
        }
      });
    },
    // 查询用户列表
    onSearch() {
      this.currentPage = 1;
      this.getPager();
    },
    // 用户分页查询
    getPager() {
      let that = this;
      that.loading = true;
      let form = that._.cloneDeep(that.searchForm);
      form.page = that.currentPage;
      form.pageSize = that.pageSize;
      getExamAgentFinishPager(form)
        .then(res => {
          if (res && res.code === 200) {
            that.tableTotal = Number(res.data.total);
            that.tablePages = Number(res.data.pages);
            that.tableData = res.data.result;
          } else {
            that.tableTotal = 0;
            that.tablePages = 0;
            that.tableData = [];
          }
        })
        .finally(() => {
          that.loading = false;
        });
    },

    // 翻页
    onCurrentPageChange(page) {
      this.currentPage = page;
      this.getPager();
    },
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.main-user {
  .dashboard {
    &-container {
      margin: 30px;
    }
    &-text {
      font-size: 30px;
      line-height: 46px;
    }
  }
  .card-fix-height {
    position: relative;
    height: calc(100vh - 36px - 15px - 102px - 52px - 72px);
  }
  .searchForm-colleapse {
    border: none;
    /deep/ .el-collapse-item__header {
      line-height: unset;
      border: none;
      cursor: auto;
    }
    /deep/ .el-form-item {
      margin-bottom: 0;
    }
    /deep/ .el-collapse-item__arrow.el-icon-arrow-right {
      cursor: pointer;
      &:before {
        content: "更多";
        color: #e93c27;
        font-size: 12px;
      }
      &.is-active {
        transform: unset;
      }
    }
    /deep/ .el-collapse-item__wrap {
      border: none;
    }
  }
  /deep/ .el-card__body {
    overflow: hidden !important;
    .el-table--enable-row-transition {
      overflow: hidden !important;
    }
  }
  ::-webkit-scrollbar {
    background-color: #f8f8ff;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #dedfe9;
  }
  .button {
    padding-bottom: 20px;
  }
}
</style>
